module.exports = __webpack_public_path__ + "static/media/icon_chat.e4e2258e.svg";